import { useEffect, useState } from "react";

/**
 * Reactive CSS media-query hook. Returns whether `query` currently matches and
 * updates on viewport changes. SSR-safe (returns false when `window` is absent).
 */
export const useMediaQuery = (query: string): boolean => {
	const [matches, setMatches] = useState(() =>
		typeof window === "undefined" ? false : window.matchMedia(query).matches,
	);

	useEffect(() => {
		const mq = window.matchMedia(query);
		const onChange = () => setMatches(mq.matches);
		onChange();
		mq.addEventListener("change", onChange);
		return () => mq.removeEventListener("change", onChange);
	}, [query]);

	return matches;
};
